import { render, staticRenderFns } from "./ProjectTaskTeam.vue?vue&type=template&id=3e1e154c&scoped=true&"
import script from "./ProjectTaskTeam.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProjectTaskTeam.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1e154c",
  null
  
)

export default component.exports